<template>
  <component
      :is="selectable ? 'label' : 'div'"
      class="free-bet"
      :class="{ 'free-bet--checked': selected, 'free-bet--selectable': selectable, 'free-bet--disabled': disabled }"
  >
    <template v-if="selectable">
      <input
          type="checkbox"
          class="free-bet__checkbox"
          :checked="selected"
          @change="$emit('toggle', $event.target.checked)"
      />
      <span class="free-bet__box">
        <v-icon v-if="selected" x-small>mdi-check-bold</v-icon>
      </span>
    </template>

    <span class="free-bet__info">
      <span class="free-bet__head">
        <span class="free-bet__name">{{ token.title || amountLabel }}</span>
        <span class="free-bet__amount-pill" v-if="token.title">{{ amountLabel }}</span>
      </span>
      <span class="free-bet__meta" v-if="token.expiresAt || token.maxWin != null">
        <span v-if="token.expiresAt">{{ $t('freeBets.expires', { date: formatFreeBetDate(token.expiresAt) }) }}</span>
        <span v-if="token.maxWin != null">{{ $t('freeBets.maxWin', { amount: formatFreeBetAmount(token.maxWin) + ' ' + currency }) }}</span>
      </span>
      <span class="free-bet__rules" v-if="showRules">{{ freeBetRules(token) }}</span>
    </span>
  </component>
</template>

<script>
import { mapGetters } from "vuex";
import freeBetInfoMixin from "@/mixins/freeBetInfoMixin";

export default {
  name: "FreeBetCard",
  mixins: [freeBetInfoMixin],
  props: {
    token: { type: Object, required: true },
    selectable: { type: Boolean, default: false },
    selected: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    // false dove la freebet è già nota come compatibile col carrello (le regole non servono).
    showRules: { type: Boolean, default: true },
  },
  computed: {
    ...mapGetters({
      getSettings: "cart/getSettings",
    }),
    currency() {
      return this.token.currency || this.getSettings.currency || '';
    },
    amountLabel() {
      return `${this.formatFreeBetAmount(this.token.amount)} ${this.currency}`.trim();
    },
  },
};
</script>

<style scoped>
/* Palette rosa / arancio della promo freebet */
.free-bet {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  background: var(--sidebar);
  border: 1px solid var(--hsla-1);
  border-radius: 8px;
  transition: border-color 0.15s, background 0.15s;
}

.free-bet--selectable {
  cursor: pointer;
}

.free-bet--selectable:hover {
  border-color: rgba(255, 138, 61, 0.45);
}

.free-bet--checked,
.free-bet--checked:hover {
  border-color: #ff8a3d;
  background:
      linear-gradient(90deg, rgba(255, 77, 141, 0.12), rgba(255, 138, 61, 0.08)),
      var(--sidebar);
}

.free-bet--disabled {
  opacity: 0.55;
}

.free-bet__checkbox {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}

.free-bet__box {
  flex: 0 0 20px;
  width: 20px;
  height: 20px;
  border-radius: 6px;
  border: 2px solid rgba(255, 138, 61, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.15s, border-color 0.15s;
}

.free-bet--checked .free-bet__box {
  border-color: transparent;
  background: linear-gradient(135deg, #ff4d8d, #ff8a3d);
}

.free-bet--checked .free-bet__box .v-icon {
  color: #fff !important;
}

.free-bet__checkbox:focus-visible + .free-bet__box {
  outline: 2px solid #ff8a3d;
  outline-offset: 2px;
}

.free-bet__info {
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1;
  min-width: 0;
}

.free-bet__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.free-bet__name {
  color: var(--text-platform);
  font-weight: 700;
  font-size: var(--font-size-4xl);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.free-bet__amount-pill {
  flex-shrink: 0;
  padding: 1px 8px;
  border-radius: 10px;
  background: linear-gradient(90deg, #ff4d8d, #ff8a3d);
  color: #fff;
  font-weight: 700;
  font-size: var(--font-size-xl);
}

/* Scadenza · vincita massima su una riga */
.free-bet__meta {
  display: flex;
  flex-wrap: wrap;
  column-gap: 6px;
  color: var(--text-op-50-platform);
  font-size: var(--font-size-xl);
}

.free-bet__meta > span + span::before {
  content: '·';
  margin-right: 6px;
}

.free-bet__rules {
  margin-top: 2px;
  color: var(--text-platform);
  font-size: var(--font-size-xl);
  line-height: 1.4;
}
</style>
